import React, { memo } from 'react';
import UnifiedPrintModal from '@/components/Print/UnifiedPrintModal';
import { Prescription } from "@/types/prescription";

interface PrintPrescriptionPreviewModalProps {
  open: boolean;
  prescription: Prescription | null;
  onClose: () => void;
}

function PrintPrescriptionPreviewModal({ 
  open, 
  prescription,
  onClose
}: PrintPrescriptionPreviewModalProps) {

  return (
    <UnifiedPrintModal
      open={open}
      onClose={onClose}
      type="prescription"
      data={prescription}
      title="Prescription Print Preview"
    />
  );
}

export default memo(PrintPrescriptionPreviewModal);